import { isEmpty, isEqual } from "lodash";
import { postUserLog } from "../../actions/common";

export const postLogForGridOperations = (
  gridRef,
  gridEvent,
  siteUId,
  eventName
) => {
  const { name, fullName, value } = gridEvent;

  if (
    name === "columns" &&
    !isEmpty(value) &&
    ["filterType", "filterValue", "filterValues"].includes(
      fullName.split(".")[1]
    )
  ) {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();

    // Get Column name from caption key if available. else get datafield value
    const colName = visibleColumns.filter((col) =>
      isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
    )[0]?.caption
      ? visibleColumns.filter((col) =>
          isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
        )[0]?.caption
      : visibleColumns.filter((col) =>
          isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
        )[0]?.dataField;

    // filtered Individual column
    if (
      fullName.split(".")[1] === "filterValues" &&
      typeof value === "object" &&
      !isEmpty(colName)
    ) {
      // postUserLog({
      //   event: `${eventName} Filter`,
      //   data: {
      //     action: `${value} filter selection`,
      //     module: "Settings",
      //     section: "Multi-Survey",
      //     siteUId,
      //     widget: "",
      //   },
      // });
      postUserLog({
        event: `${eventName} Filter`,
        data: {
          action: `${colName} filtered`,
          module: "Settings",
          section: "Multi-Survey",
          siteUId,
          widget: "",
        },
      });
    }

    if (fullName.split(".")[1] === "filterType") {
      const colName = visibleColumns[fullName.match(/\d+/)]?.caption;
      if (colName) {
        postUserLog({
          event: `${eventName} Filter`,
          data: {
            action: `${colName} filtered`,
            module: "Settings",
            section: "Multi-Survey",
            siteUId,
            widget: "",
          },
        });
      }
    }
  }

  if (name === "paging" && fullName.split(".")[1] === "pageIndex") {
    const { previousValue } = gridEvent;
    if (
      Math.abs(value - previousValue) === 1 ||
      (previousValue === undefined && value === 1)
    ) {
      postUserLog({
        event: `${eventName} View`,
        data: {
          action: `Material List ${
            previousValue === undefined
              ? "Next"
              : previousValue < value
              ? "Next"
              : "Previous"
          } Page`,
          module: "Settings",
          section: "Multi-Survey",
          siteUId,
          widget: "",
        },
      });
    }

    postUserLog({
      event: `${eventName} View`,
      data: {
        action: `Material List Page ${value + 1} clicked`,
        module: "Settings",
        section: "Multi-Survey",
        siteUId,
        widget: "",
      },
    });
  }
  // Page size showing log
  if (name === "paging" && fullName.split(".")[1] === "pageSize") {
    postUserLog({
      event: `${eventName} View`,
      data: {
        action: `Material List expanded to ${value} items`,
        module: "Settings",
        section: "Multi-Survey",
        siteUId,
        widget: "",
      },
    });
  }
};

export function isDuplicatesByProperties(arr, prop1, prop2, prop3) {
  const seen = new Map();
  return arr.reduce((duplicates, item) => {
    const key =
      item[prop1].toLowerCase() +
      "_" +
      item[prop2].toLowerCase() +
      "_" +
      item[prop3].toLowerCase();

    if (seen.has(key)) {
      duplicates.push(item);
    } else {
      seen.set(key, true);
    }

    return duplicates;
  }, []);
}

export function isDuplicatesByOneProperty(arr, prop1) {
  const seen = new Map();
  return arr.reduce((duplicates, item) => {
    const key = item[prop1].toLowerCase();

    if (seen.has(key)) {
      duplicates.push(item);
    } else {
      seen.set(key, true);
    }

    return duplicates;
  }, []);
}

export function searchValueByOneProperty(inputValue) {
  let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
  let empIDRegex = /[a-z][0-9]{6}/;
  if (!emailRegex.test(inputValue)) {
    if (!empIDRegex.test(inputValue)) {
      return "employeeName";
    } else return "employeeID";
  } else {
    return "email";
  }
}
